import { useT } from "@/lib/i18n";

export type ServiceSubcategory = { name: string; desc: string };
export type Service = {
  slug: string;
  name: string;
  desc: string;
  subcategories?: ServiceSubcategory[];
};

type RawSubcategory = { key: string; name: string; desc: string };
type RawService = {
  slug: string;
  name: string;
  desc: string;
  subcategories?: RawSubcategory[];
};

const RAW_SERVICES: RawService[] = [
  {
    slug: "derecho-penal",
    name: "Derecho Penal",
    desc: "Defensa firme en procedimientos penales, juicios rápidos y delitos graves.",
    subcategories: [
      { key: "delitos-graves", name: "Delitos graves", desc: "Defensa en causas con penas elevadas y procedimientos ante tribunales superiores." },
      { key: "juicios-rapidos", name: "Juicios rápidos", desc: "Asistencia al detenido y defensa en diligencias urgentes y procedimiento abreviado." },
      { key: "violencia-genero", name: "Violencia de género", desc: "Defensa y acusación particular con experiencia y trato cercano." },
    ],
  },
  {
    slug: "derecho-de-familia",
    name: "Derecho de Familia",
    desc: "Separaciones, divorcios, custodias, herencias, testamentos y mediación familiar.",
    subcategories: [
      { key: "divorcios", name: "Divorcios y separaciones", desc: "De mutuo acuerdo o contenciosos, atendiendo al interés superior del menor." },
      { key: "custodias", name: "Guarda, custodia y pensiones", desc: "Medidas paternofiliales, patria potestad, alimentos y su modificación o ejecución." },
      { key: "herencias", name: "Herencias y testamentos", desc: "Sucesiones, particiones, aceptación a beneficio de inventario y otorgamiento de testamento." },
      { key: "mediacion", name: "Mediación familiar", desc: "Acuerdos que evitan procesos largos y desgastantes." },
    ],
  },
  {
    slug: "derecho-laboral",
    name: "Derecho Laboral",
    desc: "Despidos, reclamaciones y conflictos colectivos.",
    subcategories: [
      { key: "despidos", name: "Despidos e indemnizaciones", desc: "Impugnación de despidos disciplinarios, objetivos y colectivos." },
      { key: "reclamaciones", name: "Reclamación de cantidad", desc: "Salarios impagados, horas extra y conceptos pendientes." },
      { key: "colectivos", name: "Conflictos colectivos", desc: "Expedientes de regulación de empleo y negociación con la representación de los trabajadores." },
    ],
  },
  {
    slug: "derecho-mercantil",
    name: "Derecho Mercantil",
    desc: "Asesoramiento integral a empresas y autónomos, derecho bancario y cooperativas.",
    subcategories: [
      { key: "societario", name: "Societario y contratos", desc: "Constitución, estatutos sociales, pactos de socios y contratación mercantil." },
      { key: "bancario", name: "Derecho bancario", desc: "Cláusulas abusivas, hipotecas, gastos, swaps y reclamaciones a entidades." },
      { key: "cooperativas", name: "Cooperativas", desc: "Asesoramiento y litigios propios del régimen cooperativo." },
    ],
  },
  {
    slug: "derecho-civil",
    name: "Derecho Civil",
    desc: "Contratos, obligaciones, responsabilidad, propiedad, inmobiliario y desahucios.",
    subcategories: [
      { key: "contratos", name: "Contratos y obligaciones", desc: "Redacción, revisión y reclamación por incumplimiento." },
      { key: "inmobiliario", name: "Derecho inmobiliario", desc: "Compraventas, arrendamientos y conflictos sobre la propiedad." },
      { key: "desahucios", name: "Desahucios", desc: "Recuperación del inmueble por impago de renta o expiración del contrato." },
      { key: "responsabilidad", name: "Responsabilidad civil", desc: "Reclamación de daños y perjuicios." },
    ],
  },
  {
    slug: "accidentes-trafico",
    name: "Accidentes de Tráfico",
    desc: "Reclamación de indemnizaciones por daños y lesiones.",
    subcategories: [
      { key: "lesiones", name: "Lesiones personales", desc: "Valoración del daño corporal y reclamación a la aseguradora." },
      { key: "danos", name: "Daños materiales", desc: "Reparación, vehículo de sustitución y supuestos de siniestro total." },
    ],
  },
  {
    slug: "extranjeria",
    name: "Extranjería",
    desc: "Permisos, nacionalidad y procedimientos migratorios.",
    subcategories: [
      { key: "residencia", name: "Permisos de residencia", desc: "Arraigo social, laboral y familiar, reagrupación y autorización de trabajo." },
      { key: "nacionalidad", name: "Nacionalidad", desc: "Por residencia, por opción y carta de naturaleza." },
      { key: "expulsiones", name: "Expulsiones y recursos", desc: "Defensa frente a procedimientos sancionadores y órdenes de expulsión." },
    ],
  },
  {
    slug: "administrativo",
    name: "Derecho Administrativo",
    desc: "Recursos y multas, urbanismo, seguridad social, consumidores y procedimientos sancionadores.",
    subcategories: [
      { key: "recursos-multas", name: "Recursos y multas", desc: "Impugnación de sanciones en vía administrativa y contencioso-administrativa." },
      { key: "urbanismo", name: "Urbanismo", desc: "Licencias, disciplina urbanística y planeamiento." },
      { key: "seguridad-social", name: "Seguridad Social", desc: "Incapacidad permanente, jubilación y reclamaciones de prestaciones." },
      { key: "consumidores", name: "Consumidores y usuarios", desc: "Reclamaciones por productos, servicios y cláusulas abusivas." },
    ],
  },
  {
    slug: "constitucional",
    name: "Derecho Constitucional",
    desc: "Recursos de amparo y defensa de derechos fundamentales.",
    subcategories: [
      { key: "amparo", name: "Recurso de amparo", desc: "Defensa de derechos fundamentales ante el tribunal competente." },
      { key: "derechos-fundamentales", name: "Derechos fundamentales", desc: "Tutela de libertades públicas y garantías constitucionales." },
      { key: "inconstitucionalidad", name: "Inconstitucionalidad de normas", desc: "Impugnación de normas contrarias a la Constitución." },
    ],
  },
  {
    slug: "tributario",
    name: "Derecho Tributario",
    desc: "Inspecciones, recursos fiscales y planificación tributaria.",
    subcategories: [
      { key: "inspecciones", name: "Inspecciones y comprobaciones", desc: "Asistencia ante la administración tributaria." },
      { key: "recursos", name: "Recursos y reclamaciones", desc: "Impugnación de liquidaciones y sanciones fiscales." },
      { key: "planificacion", name: "Planificación fiscal", desc: "Optimización tributaria para particulares y empresas." },
      { key: "fiscalidad", name: "Fiscalidad de particulares y empresas", desc: "Renta, IVA, sucesiones y donaciones e impuestos sobre inmuebles." },
    ],
  },
  {
    slug: "medico-sanitario",
    name: "Derecho Médico-Sanitario",
    desc: "Responsabilidad sanitaria y negligencias médicas.",
    subcategories: [
      { key: "negligencias", name: "Negligencias médicas", desc: "Reclamación por mala praxis y daños asistenciales." },
      { key: "responsabilidad", name: "Responsabilidad sanitaria", desc: "Frente a la sanidad pública y privada." },
      { key: "consentimiento", name: "Consentimiento informado", desc: "Defensa por falta o defecto de información al paciente." },
    ],
  },
  {
    slug: "nuevas-tecnologias",
    name: "Nuevas Tecnologías",
    desc: "Internet, comercio electrónico y derecho digital.",
    subcategories: [
      { key: "ecommerce", name: "Comercio electrónico", desc: "Aviso legal, condiciones de contratación y cumplimiento normativo de tiendas online." },
      { key: "delitos-informaticos", name: "Delitos informáticos", desc: "Fraudes, suplantación de identidad y ciberdelincuencia." },
      { key: "contratacion-tic", name: "Contratación TIC", desc: "Desarrollo de software, licencias y servicios en la nube." },
      { key: "reputacion", name: "Reputación online", desc: "Derecho al olvido y retirada de contenidos lesivos." },
    ],
  },
  {
    slug: "proteccion-datos",
    name: "Protección de Datos",
    desc: "Cumplimiento RGPD y derechos digitales.",
    subcategories: [
      { key: "cumplimiento", name: "Cumplimiento normativo", desc: "Adaptación de empresas a la normativa de privacidad y al RGPD." },
      { key: "brechas", name: "Brechas de seguridad", desc: "Gestión y notificación de incidentes de datos." },
      { key: "derechos", name: "Derechos de los interesados", desc: "Acceso, rectificación, supresión, oposición y portabilidad." },
      { key: "defensa-autoridad", name: "Defensa ante la autoridad de control", desc: "Representación en procedimientos sancionadores." },
    ],
  },
  {
    slug: "propiedad-intelectual",
    name: "Propiedad Intelectual",
    desc: "Derechos de autor y propiedad creativa.",
    subcategories: [
      { key: "autor", name: "Derechos de autor", desc: "Protección de obras literarias, artísticas y software." },
      { key: "licencias", name: "Licencias y cesiones", desc: "Contratos de explotación y distribución de derechos." },
      { key: "infracciones", name: "Infracciones y plagio", desc: "Defensa frente a usos no autorizados." },
    ],
  },
  {
    slug: "propiedad-industrial",
    name: "Propiedad Industrial",
    desc: "Marcas, patentes y diseños.",
    subcategories: [
      { key: "marcas", name: "Marcas y nombres comerciales", desc: "Registro, oposición y defensa de signos distintivos." },
      { key: "patentes", name: "Patentes y modelos de utilidad", desc: "Protección de invenciones e innovación." },
      { key: "disenos", name: "Diseños industriales", desc: "Registro y defensa de creaciones de diseño." },
      { key: "competencia-desleal", name: "Competencia desleal", desc: "Acciones frente a prácticas y aprovechamiento indebido." },
    ],
  },
  {
    slug: "concursal",
    name: "Derecho Concursal",
    desc: "Concursos de acreedores y ley de segunda oportunidad.",
    subcategories: [
      { key: "concurso", name: "Concurso de acreedores", desc: "Tramitación para empresas y particulares insolventes." },
      { key: "segunda-oportunidad", name: "Segunda oportunidad", desc: "Exoneración de deudas para personas físicas." },
      { key: "reestructuracion", name: "Reestructuración de deuda", desc: "Planes y acuerdos de refinanciación con acreedores." },
      { key: "calificacion", name: "Calificación del concurso", desc: "Defensa de administradores y responsables." },
    ],
  },
  {
    slug: "seguros",
    name: "Seguros",
    desc: "Reclamación a aseguradoras y siniestros.",
    subcategories: [
      { key: "siniestros", name: "Reclamación de siniestros", desc: "Frente a negativas o indemnizaciones insuficientes." },
      { key: "clausulas", name: "Cláusulas abusivas y limitativas", desc: "Anulación de condiciones de la póliza." },
      { key: "vida-invalidez", name: "Seguros de vida e invalidez", desc: "Reclamación de coberturas e indemnizaciones." },
      { key: "defensa-asegurado", name: "Defensa del asegurado", desc: "Vía extrajudicial y judicial frente a la aseguradora." },
    ],
  },
  {
    slug: "comunidad-propietarios",
    name: "Comunidad de Propietarios",
    desc: "Asesoría legal a comunidades de vecinos.",
    subcategories: [
      { key: "cuotas", name: "Reclamación de cuotas", desc: "Recuperación de deudas de propietarios morosos." },
      { key: "impugnacion", name: "Impugnación de acuerdos", desc: "Frente a acuerdos contrarios a la ley o a los estatutos." },
      { key: "convivencia", name: "Conflictos de convivencia", desc: "Actividades molestas, ruidos y usos indebidos." },
      { key: "junta", name: "Asesoramiento a la junta", desc: "Apoyo en gestión, obras y administración." },
    ],
  },
  {
    slug: "militar",
    name: "Derecho Militar",
    desc: "Procedimientos disciplinarios y penales militares.",
    subcategories: [
      { key: "disciplinario", name: "Régimen disciplinario", desc: "Defensa en faltas y sanciones militares." },
      { key: "penal-militar", name: "Procedimientos penales militares", desc: "Defensa ante la jurisdicción militar." },
      { key: "recursos", name: "Recursos en vía militar", desc: "Impugnación de resoluciones, destinos y ascensos." },
    ],
  },
  {
    slug: "divorcios-brasil",
    name: "Divorcios en Brasil",
    desc: "Tramitación de divorcios internacionales con Brasil.",
    subcategories: [
      { key: "internacional", name: "Divorcio internacional", desc: "Tramitación coordinada entre jurisdicciones." },
      { key: "exequatur", name: "Reconocimiento de sentencias", desc: "Homologación de resoluciones extranjeras (exequátur)." },
      { key: "hijos-bienes", name: "Medidas sobre hijos y bienes", desc: "Custodia, alimentos y partición transfronteriza." },
    ],
  },
];

/**
 * Full list of practice areas. Names and descriptions go through tk() so the
 * backoffice can translate them per locale without DB.
 */
export function useServicesList(): Service[] {
  const { tk } = useT();
  return RAW_SERVICES.map((s) => ({
    slug: s.slug,
    name: tk(`services.${s.slug}.name`, s.name),
    desc: tk(`services.${s.slug}.desc`, s.desc),
    subcategories: s.subcategories?.map((sub) => ({
      name: tk(`services.${s.slug}.sub.${sub.key}.name`, sub.name),
      desc: tk(`services.${s.slug}.sub.${sub.key}.desc`, sub.desc),
    })),
  }));
}

/**
 * Server-side variant (no hooks): used by edge contexts like /api/chat to
 * embed services in the LLM system prompt. Returns Spanish defaults only.
 */
export function getServicesListEs(): Service[] {
  return RAW_SERVICES.map((s) => ({
    slug: s.slug,
    name: s.name,
    desc: s.desc,
    subcategories: s.subcategories?.map(({ name, desc }) => ({ name, desc })),
  }));
}
